import React, { useState } from 'react';
import { Box, Container, Heading, Text, VStack, Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

const ExperiencedFAQ = ({ data }) => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <Box py={{ base: 16, md: 20 }} bg="brand.50">
      <Container maxW="container.lg">
        <VStack spacing={12}>
          <VStack spacing={4} textAlign="center">
            <Heading size="2xl" fontWeight="900" color="brand.800">
              {data.title}
            </Heading>
            <Text fontSize="lg" color="brand.500" maxW="2xl">
              {data.description}
            </Text>
          </VStack>

          <Accordion allowToggle w="full" onChange={(index) => setOpenIndex(index)}>
            {data.faqs.map((faq, index) => (
              <MotionBox
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                mb={4}
              >
                <AccordionItem
                  bg="white"
                  borderRadius="xl"
                  boxShadow="0 4px 20px rgba(0,0,0,0.08)"
                  overflow="hidden"
                >
                  <AccordionButton
                    p={6}
                    _hover={{ bg: 'brand.50' }}
                    _expanded={{ bg: 'brand.50', borderBottomRadius: 0 }}
                  >
                    <Box flex="1" textAlign="left">
                      <Heading size="md" color="brand.800">
                        {faq.question}
                      </Heading>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel pb={6} px={6}>
                    <Text color="brand.600" lineHeight="1.6">
                      {faq.answer}
                    </Text>
                  </AccordionPanel>
                </AccordionItem>
              </MotionBox>
            ))}
          </Accordion>
        </VStack>
      </Container>
    </Box>
  );
};

export default ExperiencedFAQ;